import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], total:0 , error: "", message: "" }


export const userFromSameDeaviceAction = createAsyncThunk(
    'user-from-same-device',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/admins/api/userFromSameDevice?visitorId=${data?.visitorId}&page=${data?.page}&limit=${data?.pageSize}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const userFromSameDeviceSlice = createSlice({
    name: 'user-from-same-device',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(userFromSameDeaviceAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(userFromSameDeaviceAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.total = action?.payload?.totalCount
            })
            builder.addCase(userFromSameDeaviceAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const userFormSameDeviceReducer = userFromSameDeviceSlice.reducer